import _ from 'lodash';
import { Reducer } from 'redux';
import { GetHomepageContentsAction, GET_HOMEPAGE_CONTENTS } from './actions';
import { LogoutAction, LOGOUT } from 'store/user/actions';

export interface HomepageState {
  readonly id: number;
  readonly defaultFlag: boolean;
  readonly name: string;
  readonly page: string;
  readonly text: string;
  readonly home?: string;
}

export const defaultState: HomepageState = {
  id: 0,
  defaultFlag: false,
  name: '',
  page: '',
  text: '',
  home: '',
};

export const reducer: Reducer<HomepageState, GetHomepageContentsAction | LogoutAction> = (
  state = defaultState,
  action,
) => {
  switch (action.type) {
    case GET_HOMEPAGE_CONTENTS:
      return {
        // ...state,
        // home: action.payload[0]
        ...action.payload[0],
      };
    case LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
